module.exports = __webpack_public_path__ + "static/media/placeholder.f026e141.png";